import React, { useEffect, useRef, useCallback } from 'react';
import HeroSection from '../components/home/HeroSection';
import LatestReleases from '../components/home/LatestReleases';
import FeaturedArtists from '../components/home/FeaturedArtists';
import UpcomingEvents from '../components/home/UpcomingEvents';
import LabelPhilosophy from '../components/home/LabelPhilosophy';
import ForArtistsTeaser from '../components/home/ForArtistsTeaser';
import NewsletterSection from '../components/home/NewsletterSection';

const Homepage = () => {
  const observerRef = useRef(null);

  // Function to observe fade-in elements
  const observeFadeInElements = useCallback(() => {
    if (!observerRef.current) return;
    
    const elements = document.querySelectorAll('.fade-in:not(.observed)');
    elements.forEach((el) => {
      el.classList.add('observed');
      observerRef.current.observe(el);
    });
  }, []);

  useEffect(() => {
    // Intersection Observer for scroll animations
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    // Initial observation
    observeFadeInElements();

    // Use MutationObserver to detect new fade-in elements added to DOM
    const mutationObserver = new MutationObserver(() => {
      observeFadeInElements();
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
      mutationObserver.disconnect();
    };
  }, [observeFadeInElements]);

  return (
    <div className="homepage">
      {/* Mosaic Background Elements */}
      <div className="mosaic-bg">
        <div className="mosaic-shape"></div>
        <div className="mosaic-shape"></div>
        <div className="mosaic-shape"></div>
      </div>

      <HeroSection />
      <LatestReleases />
      <FeaturedArtists />
      <UpcomingEvents />
      <LabelPhilosophy />
      <ForArtistsTeaser />
      <NewsletterSection />
    </div>
  );
};

export default Homepage;
